import React, { useState, useEffect } from "react";
import {
  Col,
  Button,
  Form,
  Row,
  Spinner,
  Card,
  Tabs,
  Tab,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { toast } from "react-toastify";
import { generateRelationNumber, generateGUID } from "assets/js/common";
import {
  createAuthorizationUrl,
  openPopup,
  getAuthorizationCode,
  exchangeCodeForToken,
  updateAsperionToken,
} from "assets/js/common";
import moment from "moment";
import AdvanceTable from "components/common/advance-table/advanceTable";
import AdvanceTableProvider from "providers/advanceTableProvider";
import useAdvanceTable from "hooks/useAdvanceTable";
import { useAppContext } from "providers/appProvider";

// Validation Schema

const SyncAsperion = () => {
  const [selectedLocationId, setSelectedLocationId] = useState();
  const [isLodaing, setIsLodaing] = useState(false);
  const [tokenData, setTokenData] = useState();
  const [userId, setUserId] = useState();
  const [isLocationSelected, setIsLocationSelected] = useState(false);
  const [asperionJobData, setAsperionJobData] = useState();
  const [loadingId, setLoadingId] = useState(null);
  const [asperionJobDataMap, setAsperionJobDataMap] = useState({});
  const [selectedAsperionJobData, setSelectedAsperionJobData] = useState([]);
  const [importButtonDisabled, setimportButtonDisabled] = useState(true);
  const { t, i18n } = useTranslation();
  const { locations, setLocations } = useAppContext();
  const [expiredTokensMap, setExpiredTokensMap] = useState({});
  const [isAsperionEnabled, setIsAsperionEnabled] = useState(false)
  const [isDataLoading, setIsDataLoading] = useState(false);

  // useEffect(() => {
  //     const locationId = localStorage.getItem("LocationId");
  //     setValue("location", locationId);
  //     // fetchAsperionData(locationId)
  // }, [])

  // useEffect(() => {
  //     const locationId = localStorage.getItem("LocationId");
  //     const userId = localStorage.getItem("UserId");
  //     fetchRelations(locationId)
  //     fetchLocation();
  //     setUserId(userId)
  //     //  fetchTokens(userId)
  // }, [locations]);

  useEffect(() => {
    fetchAsperionSettingsEnable();
  }, []);

  useEffect(() => {
    const locationId = localStorage.getItem("LocationId");
    const userId = localStorage.getItem("UserId");
    setUserId(userId);
    if (isAsperionEnabled) {
      fetchLocation();
    }
  }, [isAsperionEnabled]);

  const fetchAsperionData = async (locationId) => {
    const asperionResponse = await axios.get(
      `${process.env.REACT_APP_API_URL}/asperionJobRoute/getAsperionJobByLocationId/${locationId}`, {
      headers: {
        Authorization: process.env.REACT_APP_BasicAuthSecret
      }
    }
    );

    if (asperionResponse) {
      setSelectedAsperionJobData([asperionResponse.data]);
    }
    return asperionResponse.data;
  };

  const fetchRelations = async (locationId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/relationRoute/relations`,
        {
          params: { locationId },
          headers: {
            Authorization: process.env.REACT_APP_BasicAuthSecret
          }
        }
      );
      // Check if relationId is available and prefill the field
    } catch (error) {
      console.error("Error fetching relation data:", error);
    }
  };

  const updateAsperionSyncSettings = async (field, value) => {
    const customerId = localStorage.getItem("customerId");
    try {
      // optimistic update (UI updates immediately)
      if (field === "AsperionSyncEnabled") setIsAsperionEnabled(value);

      await axios.patch(
        `${process.env.REACT_APP_API_URL}/settingsRoute/asperionSync/updateSettings`,
        {
          CustomerId: customerId,
          AsperionSyncEnabled: field === "AsperionSyncEnabled" ? value : isAsperionEnabled,
        },
        {
          headers: {
            Authorization: process.env.REACT_APP_BasicAuthSecret
          }
        }
      );
      await handleAsperionToggleChange();
    } catch (err) {
      console.error("Failed to update settings", err);
      // rollback on error
      if (field === "AsperionSyncEnabled") setIsAsperionEnabled(!value);
    }
  };

  const fetchAsperionSettingsEnable = async () => {
    try {
      const customerId = localStorage.getItem("customerId");
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/settingsRoute/asperionSync/${customerId}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_BasicAuthSecret
          }
        }
      );
      setIsAsperionEnabled(response.data?.AsperionSyncEnabled)
    } catch (error) {
      console.error("Error fetching Asperion settings:", error);
    }
  };

  const handleAsperionToggleChange = async () => {
    const customerId = localStorage.getItem("customerId");

    try {
      //  Fetch all locations for the customer
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/locationRoute/all`,
        {
          params: { customerId },
          headers: {
            Authorization: process.env.REACT_APP_BasicAuthSecret
          }
        }
      );

      const allLocations = response.data;

      // Update sync flag for all locations in parallel
      await Promise.all(
        allLocations.map((loc) =>
          axios.post(
            `${process.env.REACT_APP_API_URL}/asperionJobRoute/addUpdateAsperionJob`,
            {
              locationId: loc.LocationId,
              isAutoSyncEnabled: false
            },
            {
              headers: { Authorization: process.env.REACT_APP_BasicAuthSecret }
            }
          )
        )
      );
    } catch (error) {
      console.error("Failed to update auto-sync for all locations:", error);
    }
  };

  // const fetchLocation = async () => {
  //     try {
  //         const loactionData = await axios.get(
  //             `${process.env.REACT_APP_API_URL}/locationRoute/all`
  //         );
  //         setLocation(loactionData.data)
  //     } catch (error) {
  //         // toast.error("Error validating permissions.");
  //         // navigate("/settings");
  //     }
  // };

  const fetchLocation = async () => {
    setIsDataLoading(true);
    try {
      const customerId = localStorage.getItem("customerId");
      if (!customerId) {
        setError("CustomerId is missing.");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/locationRoute/all`,
        {
          params: { customerId },
          headers: {
            Authorization: process.env.REACT_APP_BasicAuthSecret
          }
        }
      );
      setLocations(response.data);

      const jobDataMap = {};
      const expiredTokens = {};

      for (const loc of response.data) {
        const userId = loc.AsperionUserId;
        const jobData = await getAsperionJobData(loc.LocationId);
        // console.log("Location:", loc.LocationId, "Enabled:", jobData?.IsAutoSyncEnabled);

        let finalJobData = { ...jobData };

        try {
          const tokenRes = await axios.get(
            `${process.env.REACT_APP_API_URL}/asperionAutoTokenRoute/getToken/${userId}`, {
            headers: {
              Authorization: process.env.REACT_APP_BasicAuthSecret
            }
          });
          const token = tokenRes.data;

          const tokenValid =
            token?.AccessToken &&
            token?.RefreshToken &&
            token?.TokenExpiresAt &&
            new Date(token.TokenExpiresAt).getTime() > Date.now();

          if (!tokenValid) {
            expiredTokens[loc.LocationId] = true;

            // if (jobData?.IsAutoSyncEnabled) {
            //   // disable auto sync in DB
            //   await axios.post(
            //     `${process.env.REACT_APP_API_URL}/asperionJobRoute/addUpdateAsperionJob`,
            //     {
            //       locationId: loc.LocationId,
            //       isAutoSyncEnabled: false,
            //     }
            //   );
            //   finalJobData.IsAutoSyncEnabled = false;
            // }
          }
        } catch (err) {
          expiredTokens[loc.LocationId] = true;

          // if (jobData?.IsAutoSyncEnabled) {
          //   await axios.post(
          //     `${process.env.REACT_APP_API_URL}/asperionJobRoute/addUpdateAsperionJob`,
          //     {
          //       locationId: loc.LocationId,
          //       isAutoSyncEnabled: false,
          //     }
          //   );
          //   finalJobData.IsAutoSyncEnabled = false;
          // }
        }

        jobDataMap[loc.LocationId] = finalJobData;
      }

      setAsperionJobDataMap(jobDataMap);
      setExpiredTokensMap(expiredTokens);
    } catch (error) {
      console.error("Failed to fetch locations", error);
    } finally {
      setIsDataLoading(false);
    }
  };

  // const fetchLocation = async () => {
  //     try {
  //         const response = await axios.get(`${process.env.REACT_APP_API_URL}/locationRoute/all`);
  //         setLocations(response.data);

  //         const jobDataMap = {};
  //         for (const loc of response.data) {
  //             const jobData = await getAsperionJobData(loc.LocationId);
  //             jobDataMap[loc.LocationId] = jobData || null;
  //         }
  //         setAsperionJobDataMap({ ...jobDataMap });
  //     } catch (error) {
  //         console.error("Failed to fetch locations", error);
  //     }
  // };

  // const fetchTokens = async (userId) => {
  //     try {
  //         const asperionTokenData = await axios.get(`${process.env.REACT_APP_API_URL}/asperionTokenRoute/getAsperionTokenByUserId/${userId}`);
  //         setTokenData(asperionTokenData.data)
  //         return asperionTokenData;
  //     } catch (error) {
  //         // toast.error("Error validating permissions.");
  //         // navigate("/settings");
  //     }
  // }

  const methods = useForm({
    mode: "onChange",
  });

  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
    reset,
    setValue,
    getValues,
    trigger,
  } = methods;

  //   Function to fetch debtor data
  const getDebtorsData = async (accessToken, tenantId) => {
    let debtorsResponse;
    try {
      debtorsResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/asperionDebtorRoute/fetch`,
        {
          timeout: 120000,
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
            "x-tenant-id": tenantId, // Passing the tenant ID in the request headers
          },
        }
      );
    } catch (error) {
      if (error.response && error.response.status === 401) {
        accessToken = await refreshAccessToken(refreshToken);
        debtorsResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/asperionDebtorRoute/fetch`,
          {
            timeout: 120000,
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
              "x-tenant-id": tenantId, // Passing the tenant ID in the request headers
            },
          }
        );
      } else {
        throw error; // Rethrow other errors
      }
    }

    // const debtors = debtorsResponse.data?._data || [];
    const debtors = debtorsResponse.data || [];
    return debtors;
  };

  const saveTokensToSession = (tokenData) => {
    localStorage.setItem("access_token", tokenData.access_token);
    localStorage.setItem("refresh_token", tokenData.refresh_token);
  };

  const createNewRelation = async (debitor, locationId, customerId) => {
    const primaryContact = debitor.contacts?.[0];
    const newrelationBody = {
      relationNumber: await generateRelationNumber(),
      customerId,
      contactperson:
        primaryContact?.name ||
        debitor.contactPersonName ||
        debitor.name,
      email1: debitor.emailAddress,
      name: debitor.name,
      // contactperson: debitor.name,
      invoiceEmail: debitor.emailAddress,
      postcode: debitor.postCode,
      city: debitor.city,
      country: "Nederland",
      phoneNumber: debitor.phoneNumber,
      mobileNumber: debitor.mobileNumber,
      cocNumber: debitor.cocNumber,
      vatNumber: debitor.vatNumber,
      iban: debitor.iban,
      status: "0",
      type: "0",
      asperionSource: "1",
      houseNumber: null,
      locationId,
      streetName: debitor.address,
      asperionRelationId: debitor.id,
      asperionRelationCustomerNumber: debitor.customerNumber,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/relationRoute/relation`,
        newrelationBody, {
        headers: {
          Authorization: process.env.REACT_APP_BasicAuthSecret
        }
      }
      );
      return response.status === 201;
    } catch (error) {
      // console.error("Error creating relation:", error);
      return false;
    }
  };

  const getAsperionJobData = async (locationId) => {
    const asperionResponse = await axios.get(
      `${process.env.REACT_APP_API_URL}/asperionJobRoute/getAsperionJobByLocationId/${locationId}`, {
      headers: {
        Authorization: process.env.REACT_APP_BasicAuthSecret
      }
    }
    );
    return asperionResponse.data;
  };

  const createAsperionJobData = (
    locationId,
    newRelationsLength,
    existingTotalImports,
    isAutoSyncEnabled = false
  ) => {
    const newImportsInt = parseInt(newRelationsLength, 10) || 0; // Default to 0 if conversion fails
    const existingImportsInt = parseInt(existingTotalImports, 10) || 0; // Default to 0 if conversion fails
    return {
      locationId,
      jobId: generateGUID(),
      jobDate: moment().toDate(),
      newImports: newImportsInt,
      existingImports: existingImportsInt,
      totalImports: existingImportsInt + newImportsInt,
      isAutoSyncEnabled,
    };
  };

  // const onSubmit = async (data) => {
  //     setIsLodaing(true);

  //     if (!isLocationSelected) {
  //         toast.error(`Selecteer de locatie`, { position: "top-right", autoClose: 5000 });
  //         setIsLodaing(false);
  //         return;
  //     }

  //     try {
  //         const authorizationUrl = createAuthorizationUrl();
  //         const popup = openPopup(authorizationUrl);

  //         if (!popup) {
  //             console.error("Failed to open popup. Please allow popups for this site.");
  //             setIsLodaing(false);
  //             return;
  //         }
  //         const authorizationCode = await getAuthorizationCode(popup);
  //         const tokenData = await exchangeCodeForToken(authorizationCode);
  //         saveTokensToSession(tokenData);

  //         const tokenDataBody = {
  //             userId: userId,
  //             accessToken: tokenData.access_token,
  //             refreshToken: tokenData.refresh_token
  //         };
  //         await updateAsperionToken(tokenDataBody);

  //         const locationId = getValues("location") || selectedLocationId;
  //         const response = await axios.get(`${process.env.REACT_APP_API_URL}/locationRoute/getById/${locationId}`);
  //         const locationData = response.data;

  //         const debitors = await getDebtorsData(tokenData.access_token, locationData.AsperionTenantId);
  //         const relationResponse = await axios.get(`${process.env.REACT_APP_API_URL}/relationRoute/relations`, { params: { locationId } });
  //         const relationData = relationResponse.data;
  //         let newRelationsLength = 0;
  //         const debitorsLength = debitors.length;
  //         for (const debitor of debitors) {
  //             if (debitor.id) {
  //                 const relationExists = relationData.some(relation => {
  //                     return String(relation.AsperionRelationId) === String(debitor.id);
  //                 });
  //                 if (!relationExists) {
  //                     const created = await createNewRelation(debitor, locationId);
  //                     if (created) newRelationsLength += 1;
  //                 }
  //             }
  //         }

  //         const asperionResponse = await getAsperionJobData(locationId);
  //         let asperionData;

  //         if (asperionResponse) {
  //             asperionData = createAsperionJobData(locationId, newRelationsLength, asperionResponse.TotalImports);
  //         } else {
  //             asperionData = createAsperionJobData(locationId, newRelationsLength, 0);
  //         }

  //         await axios.post(`${process.env.REACT_APP_API_URL}/asperionJobRoute/addUpdateAsperionJob`, asperionData);
  //         await fetchAsperionData(locationId);

  //         toast.success(`${newRelationsLength} van de ${debitorsLength} relaties worden gesynchroniseerd.`, { position: "top-right", autoClose: 5000 });

  //     } catch (error) {
  //         toast.error(`Fout bij het synchroniseren van de relatie`, { position: "top-right", autoClose: 5000 });
  //         console.error("Error during the login process:", error);
  //     } finally {
  //         setIsLodaing(false);
  //     }
  // };

  // const handleImport = async (locationId) => {
  //   setLoadingId(locationId);

  //   try {
  //     const authorizationUrl = createAuthorizationUrl();
  //     const popup = openPopup(authorizationUrl);

  //     if (!popup) {
  //       console.error(
  //         "Failed to open popup. Please allow popups for this site."
  //       );
  //       setLoadingId(null);
  //       return;
  //     }

  //     const authorizationCode = await getAuthorizationCode(popup);
  //     const tokenData = await exchangeCodeForToken(authorizationCode);
  //     saveTokensToSession(tokenData);

  //     await updateAsperionToken({
  //       userId,
  //       accessToken: tokenData.access_token,
  //       refreshToken: tokenData.refresh_token,
  //     });

  //     const locationResponse = await axios.get(
  //       `${process.env.REACT_APP_API_URL}/locationRoute/getById/${locationId}`
  //     );
  //     const locationData = locationResponse.data;
  //     const debitors = await getDebtorsData(
  //       tokenData.access_token,
  //       locationData.AsperionTenantId
  //     );

  //     const relationResponse = await axios.get(
  //       `${process.env.REACT_APP_API_URL}/relationRoute/relations`,
  //       { params: { locationId } }
  //     );
  //     const relationData = relationResponse.data;

  //     let newRelationsLength = 0;
  //     for (const debitor of debitors) {
  //       if (debitor.id) {
  //         const exists = relationData.some(
  //           (r) => String(r.AsperionRelationId) === String(debitor.id)
  //         );
  //         if (!exists) {
  //           const created = await createNewRelation(debitor, locationId);
  //           if (created) newRelationsLength++;
  //         }
  //       }
  //     }

  //     const asperionResponse = await getAsperionJobData(locationId);
  //     const asperionData = createAsperionJobData(
  //       locationId,
  //       newRelationsLength,
  //       asperionResponse?.TotalImports || 0,
  //       asperionResponse?.IsAutoSyncEnabled ?? false
  //     );

  //     await axios.post(
  //       `${process.env.REACT_APP_API_URL}/asperionJobRoute/addUpdateAsperionJob`,
  //       asperionData
  //     );
  //     await fetchAsperionData(locationId);
  //     await fetchLocation(); // refresh table

  //     toast.success(
  //       `${newRelationsLength} ${t("relationsSyncedP1")} ${debitors.length} ${t(
  //         "relationsSyncedP2"
  //       )} ${locationData.Name}`,
  //       { position: "top-right", autoClose: 5000 }
  //     );
  //   } catch (error) {
  //     toast.error(t("relationsImportError"), {
  //       position: "top-right",
  //       autoClose: 5000,
  //     });
  //     console.error("Error during the login process:", error);
  //   } finally {
  //     setLoadingId(null);
  //   }
  // };

  const handleImport = async (locationId) => {
    setLoadingId(locationId);

    try {
      // Step 1: Fetch location info to get AsperionUserId and TenantId
      const locationResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/locationRoute/getById/${locationId}`, {
        headers: {
          Authorization: process.env.REACT_APP_BasicAuthSecret
        }
      }
      );
      const locationData = locationResponse.data;
      const asperionUserId = locationData.AsperionUserId;
      const tenantId = locationData.AsperionTenantId;

      // Step 2: Try to fetch token from DB
      let token = null;
      try {
        const tokenResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/asperionAutoTokenRoute/getToken/${asperionUserId}`, {
          headers: {
            Authorization: process.env.REACT_APP_BasicAuthSecret
          }
        });
        const t = tokenResponse.data;
        const isValid =
          t?.AccessToken &&
          t?.RefreshToken &&
          t?.TokenExpiresAt &&
          new Date(t.TokenExpiresAt).getTime() > Date.now();

        token = isValid ? t : null;
      } catch {
        token = null;
      }

      // Step 3: If no valid token, prompt login
      if (!token) {
        const popup = openPopup(createAuthorizationUrl());
        if (!popup) {
          toast.error("Popup blocked. Please allow popups for this site.");
          setLoadingId(null);
          return;
        }

        const code = await getAuthorizationCode(popup);
        const tokenData = await exchangeCodeForToken(code);
        const resolvedUser =
          tokenData?.id_token_claims?.preferred_username || asperionUserId;

        await axios.post(
          `${process.env.REACT_APP_API_URL}/asperionAutoTokenRoute/saveToken`,
          {
            asperionUserId: resolvedUser,
            accessToken: tokenData.access_token,
            refreshToken: tokenData.refresh_token,
            expiresIn: tokenData.expires_in,
          },
          {
            headers: {
              Authorization: process.env.REACT_APP_BasicAuthSecret
            }
          }
        );

        token = {
          AccessToken: tokenData.access_token,
          RefreshToken: tokenData.refresh_token,
        };
      }

      // Step 4: Fetch debtors
      const debtorsRes = await axios.get(
        `${process.env.REACT_APP_API_URL}/asperionDebtorRoute/fetch`,
        {
          timeout: 120000,
          headers: {
            Authorization: `Bearer ${token.AccessToken}`,
            "x-tenant-id": tenantId,
          },
        }
      );
      const debtors = debtorsRes.data || [];

      // Step 5: Get existing relations
      const customerId = localStorage.getItem("customerId");
      if (!customerId) {
        setLoadingId(null);
        setError("CustomerId is missing.");
        return;
      }

      const relationsRes = await axios.get(
        `${process.env.REACT_APP_API_URL}/relationRoute/relations`,
        {
          params: { locationId, customerId },
          headers: {
            Authorization: process.env.REACT_APP_BasicAuthSecret
          }
        }
      );
      const relationData = relationsRes.data;
      let newRelationsLength = 0;

      for (const debitor of debtors) {
        const exists = relationData.some(
          (r) => String(r.AsperionRelationId) === String(debitor.id)
        );
        if (!exists) {
          
          const created = await createNewRelation(debitor, locationId, customerId);
          if (created) newRelationsLength++;
        }
      }

      // Step 6: Update Job Data
      const asperionResponse = await getAsperionJobData(locationId);
      const asperionData = createAsperionJobData(
        locationId,
        newRelationsLength,
        asperionResponse?.TotalImports || 0,
        asperionResponse?.IsAutoSyncEnabled ?? false
      );

      await axios.post(
        `${process.env.REACT_APP_API_URL}/asperionJobRoute/addUpdateAsperionJob`,
        asperionData, {
        headers: {
          Authorization: process.env.REACT_APP_BasicAuthSecret
        }
      }
      );

      await fetchAsperionData(locationId);
      await fetchLocation();

      toast.success(
        `${newRelationsLength} new / ${debtors.length} total relations synced for ${locationData.Name}`,
        { position: "top-right", autoClose: 5000 }
      );
    } catch (error) {
      toast.error("Failed to import relations.");
      console.error(error);
    } finally {
      setLoadingId(null);
    }
  };

  // const columns = [
  //     {
  //         header: 'Sr.No',
  //         meta: {
  //             headerProps: { className: 'text-900' }
  //         },
  //         cell: ({ cell }) => <span>1</span>,
  //     },
  //     {
  //         accessorKey: 'Last Sync Date',
  //         header: 'JobDate',
  //         meta: {
  //             headerProps: { className: 'text-900' }
  //         },
  //         cell: ({ row: { original } }) => <span>{original?.JobDate ? moment(original.JobDate).format("DD-MMMM-YYYY") : "--"}</span>
  //     },
  //     {
  //         accessorKey: 'New Imports',
  //         header: 'NewImports',
  //         meta: {
  //             headerProps: { className: 'text-900' }
  //         },
  //         cell: ({ row: { original } }) => <span>{original?.NewImports || "--"}</span>
  //     },
  //     {
  //         accessorKey: 'Existing Imports',
  //         header: 'ExistingImports',
  //         meta: {
  //             headerProps: { className: 'text-900' }
  //         },
  //         cell: ({ row: { original } }) => <span>{original?.ExistingImports || "--"}</span>
  //     },
  //     {
  //         accessorKey: 'Total Imports',
  //         header: 'TotalImports',
  //         meta: {
  //             headerProps: { className: 'text-900' }
  //         },
  //         cell: ({ row: { original } }) => <span>{original?.TotalImports || "--"}</span>
  //     },
  // ];

  const columns = [
    {
      header: t("no"),
      meta: {
        headerProps: { className: "text-900" },
      },
      cell: ({ row }) => <span>{row.index + 1}</span>,
    },
    {
      accessorKey: "Name",
      header: t("branch"),
      cell: ({ row: { original } }) => <span>{original.Name}</span>,
    },
    {
      accessorKey: "LastSyncDate",
      header: t("syncDate"),
      cell: ({ row: { original } }) => {
        const job = asperionJobDataMap[original.LocationId];
        return (
          <span>
            {job?.JobDate ? moment(job.JobDate).format("DD-MMMM-YYYY") : "--"}
          </span>
        );
      },
    },
    {
      accessorKey: "NewImports",
      header: t("new"),
      cell: ({ row: { original } }) => {
        const job = asperionJobDataMap[original.LocationId];
        return <span>{job?.NewImports ?? "--"}</span>;
      },
    },
    {
      accessorKey: "ExistingImports",
      header: t("existing"),
      cell: ({ row: { original } }) => {
        const job = asperionJobDataMap[original.LocationId];
        return <span>{job?.ExistingImports ?? "--"}</span>;
      },
    },
    {
      accessorKey: "TotalImports",
      header: t("total"),
      cell: ({ row: { original } }) => {
        const job = asperionJobDataMap[original.LocationId];
        return <span>{job?.TotalImports ?? "--"}</span>;
      },
    },
    {
      header: t("autoSync"),
      cell: ({ row: { original } }) => {
        const job = asperionJobDataMap[original.LocationId];
        const isEnabled = job?.IsAutoSyncEnabled ?? false;
        const isTokenExpired = expiredTokensMap?.[original.LocationId];

        const handleToggleChange = async (e) => {
          const isChecked = e.target.checked;
          const locationId = original.LocationId;
          const usernameFromLocation = original.AsperionUserId;

          try {
            // Always update the auto-sync flag (immediately on click)
            await axios.post(
              `${process.env.REACT_APP_API_URL}/asperionJobRoute/addUpdateAsperionJob`,
              {
                locationId,
                isAutoSyncEnabled: isChecked,
              },
              {
                headers: {
                  Authorization: process.env.REACT_APP_BasicAuthSecret
                }
              }
            );

            // If disabling, done
            if (!isChecked) {
              toast.success(
                t("autoSyncDisableSuccess", { location: original.Name }),
                { position: "top-right", autoClose: 3000 }
              );
              fetchLocation();
              return;
            }

            // If enabling, validate token
            let needsLogin = false;

            try {
              const tokenCheck = await axios.get(
                `${process.env.REACT_APP_API_URL}/asperionAutoTokenRoute/getToken/${usernameFromLocation}`,
                {
                  headers: {
                    Authorization: process.env.REACT_APP_BasicAuthSecret
                  }
                }
              );

              const token = tokenCheck.data;
              const tokenValid = !!(token?.AccessToken && token?.RefreshToken);

              if (!tokenValid) {
                needsLogin = true;
              } else if (token?.TokenExpiresAt) {
                const expiry = new Date(token.TokenExpiresAt).getTime();
                const now = Date.now();
                if (expiry < now) {
                  needsLogin = true;
                }
              }
            } catch (error) {
              if (error.response?.status === 404) {
                needsLogin = true; // token not found
              } else {
                throw error; // other errors
              }
            }

            if (needsLogin) {
              // Launch Asperion login popup
              const authUrl = createAuthorizationUrl();
              const popup = openPopup(authUrl);
              if (!popup) {
                toast.error(t("autoSyncLoginPopupError"), {
                  position: "top-right",
                  autoClose: 3000,
                });
                return;
              }

              const code = await getAuthorizationCode(popup);
              const tokenData = await exchangeCodeForToken(code);

              const actualUsername =
                tokenData?.id_token_claims?.preferred_username ||
                usernameFromLocation;

              // Save token
              await axios.post(
                `${process.env.REACT_APP_API_URL}/asperionAutoTokenRoute/saveToken`,
                {
                  asperionUserId: actualUsername,
                  accessToken: tokenData.access_token,
                  refreshToken: tokenData.refresh_token,
                  expiresIn: tokenData.expires_in,
                },
                {
                  headers: {
                    Authorization: process.env.REACT_APP_BasicAuthSecret
                  }
                }
              );

              toast.success(
                t("autoSyncEnableSuccess", { location: original.Name }),
                { position: "top-right", autoClose: 3000 }
              );
            } else {
              // Token exists and is valid
              toast.success(
                t("autoSyncEnableSuccess", { location: original.Name }),
                { position: "top-right", autoClose: 3000 }
              );
            }

            fetchLocation();
          } catch (err) {
            toast.error(t("autoSyncUpdateError"), {
              position: "top-right",
              autoClose: 3000,
            });
            console.error(err);
          }
        };

        return (
          <div className="d-flex align-items-center gap-2">
            <Form.Check
              type="switch"
              id={`auto-sync-${original.LocationId}`}
              // checked={!isTokenExpired && isEnabled} // ⛔ force toggle off if token expired
              checked={isEnabled}
              onChange={handleToggleChange}
            />

            {isTokenExpired && (
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>{t("tokenExpired")}</Tooltip>}
              >
                <i className="fas fa-exclamation-triangle text-warning ms-2" />
              </OverlayTrigger>
            )}
          </div>
        );
      },
    },
    {
      header: t("action"),
      cell: ({ row: { original } }) => {
        const job = asperionJobDataMap[original.LocationId];
        const isSynced = job?.JobDate; // Check if it has been synced before

        return isSynced ? (
          // Display sync icon when previously synced
          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => handleImport(original.LocationId)} // handleSync could trigger a sync action
            disabled={loadingId === original.LocationId}
          >
            {loadingId === original.LocationId ? (
              <>
                <i className="fas fa-sync-alt me-2"></i>
                {t("syncing")}
              </>
            ) : (
              <i className="fas fa-sync-alt"></i>
            )}
          </Button>
        ) : (
          // Display 'Importeren' when never synced
          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => handleImport(original.LocationId)}
            disabled={loadingId === original.LocationId}
          >
            {loadingId === original.LocationId ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />{" "}
                Bezig...
              </>
            ) : (
              t("import")
            )}
          </Button>
        );
      },
    },
  ];

  const table = useAdvanceTable({
    data: locations,
    columns,
    sortable: true,
    pagination: true,
  });

  return isLodaing ? (
    <div className="text-center my-5">
      <span>{t("importRelations")}</span>
      <Spinner animation="border" role="status"></Spinner>
    </div>
  ) : (
    <>
      <FormProvider {...methods}>
        <div className="p-3">
          <h6 className="d-flex justify-content-between align-items-center bg-body-tertiary p-3 fw-semi-bold ls fs-9 data-font-colour">{t("asperionSync")}
            <Form.Check
              type="switch"
              id="toggle-table"
              label={isAsperionEnabled? t("enable"): t("disable")}
              checked={isAsperionEnabled}
              onChange={(e) =>
                updateAsperionSyncSettings(
                  "AsperionSyncEnabled",
                  e.target.checked
                )
              }
            />
          </h6>
          {isAsperionEnabled && (
            isDataLoading ? (
              <div className="text-center my-4">
                <Spinner animation="border" role="status" />
                <div className="mt-2">{t("loading")}</div>
              </div>
            ) : (
              <AdvanceTableProvider {...table}>
                <AdvanceTable
                  headerClassName="bg-200 text-nowrap align-middle"
                  rowClassName="align-middle white-space-nowrap"
                  tableProps={{
                    bordered: true,
                    striped: true,
                    size: "sm",
                    className: "mb-0 overflow-hidden data-font-size table-hover",
                  }}
                />
              </AdvanceTableProvider>
            )
          )}
          {locations.length === 0 && (
            <div className="text-center pt-4">{t("noDataAvailableText")}</div>
          )}
        </div>
      </FormProvider>
    </>
  );
};

export default SyncAsperion;
